var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVicidial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.59 34.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-v1 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-v1, .cls-v2 {\r\n        fill: none;\r\n        stroke: currentColor;\r\n      }\r\n\r\n      .cls-v2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-v3 {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-v2",
    cx: 12.96,
    cy: 7.57,
    rx: 6.14,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-v1",
    d: "M16.87,17.61h-7.82c-4.72,0-8.55,3.83-8.55,8.55v6.47c0,.8.65,1.45,1.45,1.45h22.21c.8,0,1.45-.65,1.45-1.45v-3.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-v1",
    x1: 19.84,
    y1: 27.1,
    x2: 19.84,
    y2: 34.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-v1",
    x1: 5.8,
    y1: 27.1,
    x2: 5.8,
    y2: 33.79
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-v2",
    cx: 27.1,
    cy: 17.32,
    r: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-v3",
    d: "M30.14,18.57c-.21-.22-.47-.34-.75-.34s-.53.12-.76.34l-.7.7c-.06-.03-.12-.06-.17-.09-.08-.04-.15-.08-.22-.12-.65-.42-1.25-.96-1.82-1.66-.28-.35-.46-.64-.6-.94.18-.17.35-.34.51-.5.06-.06.12-.13.19-.19.46-.46.46-1.07,0-1.53l-.6-.6c-.07-.07-.14-.14-.21-.21-.13-.14-.27-.28-.42-.41-.21-.21-.47-.33-.74-.33s-.53.11-.75.33h0s-.75.76-.75.76c-.28.28-.44.63-.48,1.03-.05.65.14,1.25.28,1.64.36.97.89,1.86,1.69,2.82.97,1.16,2.13,2.07,3.47,2.71.51.24,1.19.53,1.95.58.05,0,.1,0,.14,0,.51,0,.94-.18,1.28-.55,0,0,0,0,0-.01.12-.14.25-.27.39-.4.1-.09.19-.19.29-.29.22-.23.33-.49.33-.77s-.12-.54-.34-.76l-1.21-1.22ZM30.93,20.9s0,0,0,0c-.09.09-.17.18-.27.27-.14.14-.29.28-.43.44-.22.24-.49.35-.83.35-.03,0-.07,0-.1,0-.66-.04-1.27-.3-1.73-.52-1.25-.61-2.35-1.47-3.26-2.56-.75-.91-1.26-1.75-1.59-2.65-.21-.55-.28-.98-.25-1.38.02-.26.12-.47.31-.66l.75-.75c.11-.1.22-.16.34-.16.14,0,.25.08.32.15,0,0,0,0,0,0,.13.13.26.26.4.4.07.07.14.14.21.21l.6.6c.23.23.23.45,0,.69-.06.06-.13.13-.19.19-.19.19-.36.37-.56.54,0,0,0,0-.01.01-.19.19-.15.38-.12.5,0,0,0,.01,0,.02.16.38.38.74.71,1.17h0c.61.75,1.25,1.34,1.96,1.79.09.06.18.1.27.15.08.04.15.08.22.12,0,0,.02.01.03.02.08.04.15.06.22.06.18,0,.3-.12.34-.15l.76-.76c.08-.08.19-.17.33-.17s.25.09.32.16h0s1.22,1.22,1.22,1.22c.23.23.23.46,0,.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-v3",
    d: "M27.52,14.57c.58.1,1.11.37,1.53.79s.69.95.79,1.53c.02.15.15.25.29.25.02,0,.03,0,.05,0,.16-.03.27-.18.25-.35-.12-.7-.45-1.34-.96-1.85s-1.15-.84-1.85-.96c-.16-.03-.32.08-.35.24s.08.32.24.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-v3",
    d: "M32.32,16.7c-.2-1.15-.74-2.21-1.58-3.04s-1.89-1.38-3.04-1.58c-.16-.03-.31.08-.34.24-.03.16.08.32.25.35,1.03.17,1.97.66,2.72,1.41.75.75,1.23,1.69,1.41,2.72.02.15.15.25.29.25.02,0,.03,0,.05,0,.16-.02.27-.18.24-.34Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVicidial);
export default __webpack_public_path__ + "static/media/Vicidial.b10d9946a85a1ac13cd19fa8586aba80.svg";
export { ForwardRef as ReactComponent };